export default __webpack_public_path__ + "static/media/flag-zh-CN.c824f6ad.svg";